import React from 'react';
import * as yup from 'yup';

import { StyleProps } from '$/components/ui';

import {
  InteractionModalAccordionsHook,
  InteractionModalComponentProps,
  ModalValidationRules,
} from '$/components/Interactions/types';
import { InteractionInfo, NoBodyCard } from '$/components/Interactions/InteractionInfo';
import type { InteractionModalTitleProps } from '$/components/Interactions/types';

import { KofiIcon } from '$/images/FontAwesomeIcons';

import { AnalyticsCardProps } from '../cards/types';
import { TipWithKoFiCard } from './TipWithKoFiCard';
import { useTipWithKoFiSettings } from './useTipWithKoFiSettings';

const AnalyticsClickCard = React.lazy(() => import('../cards/AnalyticsClickCard'));
const TipWithKoFiModal = React.lazy(() => import('./TipWithKoFiModal'));

export class TipWithKoFiInfo extends InteractionInfo {
  public typeName(): string | undefined {
    return `Collect tips with Ko-fi`;
  }

  public title(): string {
    return `How about it?`;
  }

  public icon(): React.FC<StyleProps> {
    return KofiIcon;
  }

  public modalValidationRules(): ModalValidationRules {
    return {
      // making "title" & "description" not required at yup level,
      // they will fall back to integration info default
      title: yup.string().trim().default(this.title()),
      description: yup.string().trim(),
      username: yup.string().trim().nullable().required(),
    };
  }

  public hasExpiresInField(): boolean {
    return false;
  }

  public hasPropertyNameField(): boolean {
    return false;
  }

  public hasExpiresInReplayToggle(): boolean {
    return false;
  }

  public hasEndsAt(): boolean {
    return false;
  }

  public isInteractiveCard(): boolean {
    return false;
  }

  public cardComponent(): React.FC<{ onClickHeader?: (() => void) | undefined }> {
    return TipWithKoFiCard;
  }

  public modalTitleComponent(): React.FC<InteractionModalTitleProps> | null {
    return null;
  }

  public useModalPreviewComponent(): React.LazyExoticComponent<
    React.FC<InteractionModalComponentProps>
  > | null {
    return TipWithKoFiModal;
  }

  public modalSettingsAccordions(): InteractionModalAccordionsHook {
    return useTipWithKoFiSettings;
  }

  public cardBodyComponent(): React.FC {
    return NoBodyCard;
  }

  public analyticsCardComponent(): React.LazyExoticComponent<React.FC<AnalyticsCardProps>> {
    return AnalyticsClickCard;
  }
}
